module.exports = __webpack_public_path__ + "static/kengon-3411c4b3e82c3adc4b9b89de47d7f76d.png";